// @ts-ignore
export const all = (state) => state.all;

// @ts-ignore
export const categories = (state) => {
  let cats: any[] = [];

  state.all.forEach((file: any) => {
    cats = [...new Set(cats.concat(file.categories))];
  });

  return cats;
};
